import { Box, Typography } from '@mui/material';
import { theme } from 'common/constants/theme';
import { Styles } from 'common/types';
import { IProduct } from 'common/ui/product/types';
import { ReactElement } from 'react';

interface StylesProps {
  image: string;
}

const getStyles = ({ image }: StylesProps): Styles => ({
  container: {
    backgroundColor: 'transparent',
    borderRadius: '8px',
    padding: theme.spacing(0.5, 2),
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box',
    marginTop: 1,
    cursor: 'pointer',
    maxWidth: '400px',
    border: '1px solid #C2DEEB',

    ':first-child': {
      marginTop: 0,
    },
  },
  title: {
    fontSize: 14,
    minWidth: '130px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  alertIcon: { marginLeft: 1, color: '#F65147' },
  inStockIcon: { marginLeft: 1, color: '#62D294' },
  starIcon: { color: '#FFD645' },
  image: { width: 64, minWidth: 64, height: 64, backgroundImage: `url(${image})`, backgroundSize: 'contain' },
  textWrapper: { display: 'flex', flexDirection: 'row' },
  textContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginLeft: 2,
    flexGrow: 1,
  },
  titleContainer: { display: 'flex', flexDirection: 'column' },
  asin: { color: '#6F8490', fontSize: '12px' },
  reviewsText: { fontSize: 10, ml: 1, lineHeight: 1, color: '#6F8490' },
  reviewsTitleText: { color: '#214254', fontSize: 10, opacity: 0.65 },
  ratingContent: { display: 'flex', alignItems: 'center' },
  avgReviewsText: { lineHeight: 1 },
});

interface Props {
  product: IProduct;
}

export function Product({ product }: Props): ReactElement {
  const styles = getStyles({
    image: product?.img_small || product?.img_large,
  });

  const handleOpenProduct = () => {
    window.open(`https://www.amazon.com/dp/${product?.asin}`);
  };

  return (
    <Box sx={styles.container} onClick={handleOpenProduct}>
      <Box sx={styles.image} />
      <Box sx={styles.textContent}>
        <Box sx={styles.textWrapper}>
          <Box sx={styles.titleContainer}>
            <Typography sx={styles.asin}>{product.asin}</Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
